import React from 'react';

// Base shimmer block. Uses the emerald-tinted surface so skeletons read as
// "this brand's content is loading" rather than a generic gray placeholder.
export const SkeletonBlock = ({ className = '' }) => (
  <div className={`animate-pulse rounded-lg bg-emerald-50 ${className}`} />
);

export const ProductCardSkeleton = () => (
  <div className="bg-white rounded-2xl border border-emerald-100/70 shadow-soft overflow-hidden flex flex-col">
    <SkeletonBlock className="aspect-square rounded-none" />
    <div className="p-4 flex flex-col gap-2.5">
      <SkeletonBlock className="h-4 w-4/5" />
      <SkeletonBlock className="h-3 w-2/5" />
      <div className="flex items-center justify-between pt-2 mt-auto">
        <SkeletonBlock className="h-5 w-14" />
        <SkeletonBlock className="h-8 w-16 rounded-full" />
      </div>
    </div>
  </div>
);

export const ProductGridSkeleton = ({ count = 8 }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <ProductCardSkeleton key={i} />
    ))}
  </div>
);

export const CategoryCardSkeleton = () => (
  <div className="bg-white rounded-3xl border border-emerald-100/70 shadow-soft overflow-hidden">
    <SkeletonBlock className="h-[120px] sm:h-[160px] lg:h-[200px] rounded-none" />
    <div className="p-4 flex flex-col gap-2">
      <SkeletonBlock className="h-4 w-3/5" />
      <SkeletonBlock className="h-3 w-2/5" />
    </div>
  </div>
);

export const CategoryGridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <CategoryCardSkeleton key={i} />
    ))}
  </div>
);

export const OrderCardSkeleton = () => (
  <div className="bg-white rounded-2xl border border-emerald-100 shadow-card p-5 flex items-center justify-between gap-4">
    <div className="flex-1 flex flex-col gap-2.5">
      <SkeletonBlock className="h-4 w-1/3" />
      <SkeletonBlock className="h-3 w-1/4" />
    </div>
    <SkeletonBlock className="h-7 w-24 rounded-full" />
  </div>
);

export const OrderListSkeleton = ({ count = 4 }) => (
  <div className="space-y-4">
    {Array.from({ length: count }).map((_, i) => (
      <OrderCardSkeleton key={i} />
    ))}
  </div>
);

export const CartLineSkeleton = () => (
  <div className="bg-white rounded-2xl border border-emerald-100 shadow-card p-4 flex gap-4 items-center">
    <SkeletonBlock className="w-20 h-20 rounded-xl shrink-0" />
    <div className="flex-1 flex flex-col gap-2.5">
      <SkeletonBlock className="h-4 w-3/5" />
      <SkeletonBlock className="h-3 w-1/4" />
    </div>
    <SkeletonBlock className="h-8 w-24 rounded-full" />
  </div>
);
